import React from 'react';
import Button from '../Button/Button';
import './DialogFooter.css';

/**
 * @function Wrapper component for Dialog footer buttons
 *
 * Accepts props of:
 * @param {array} buttons - array of button objects to be rendered inside DialogFooter
 *
 * @example Button options need to include property of 'leftFloat' or 'rightFloat' {boolean} to determine where it will be rendered in footer
 *
 * @return {JSX} Component that wraps footer buttons
 */
export class DialogFooter extends React.PureComponent {
    render() {
        const { buttons } = this.props;

        return (
            <div className="dialogActionContainer">
                <div className="floatLeft">
                    {buttons.filter((option) => option.leftFloat).map((option) => (
                        <Button
                            key={`${option.text}-${option.type}`}
                            content={option.text}
                            className={`dialogButton ${option.className}`}
                            variant={option.variant}
                            type={option.type}
                            icon={option.icon}
                            disabled={option.disabled}
                            onClick={option.onButtonClick}
                            {...option['data-testid']}
                        />
                    ))}
                </div>
                <div className="floatRight">
                    {buttons.filter((option) => option.rightFloat).map((option) => (
                        <Button
                            id={option.id}
                            key={`${option.text}-${option.type}`}
                            content={option.text}
                            className={`dialogButton ${option.className}`}
                            variant={option.variant}
                            type={option.type}
                            icon={option.icon}
                            disabled={option.disabled}
                            onClick={option.onButtonClick}
                            {...option['data-testid']}
                        />
                    ))}
                </div>
            </div>
        );
    }
}

export default DialogFooter;
